Object.defineProperty(exports, "__esModule", { value: true });
exports.biomeDarkColorTokens = exports.biomeLightColorTokens = void 0;
var biome_light_1 = require("./biome-light");
Object.defineProperty(exports, "biomeLightColorTokens", { enumerable: true, get: function () { return biome_light_1.biomeLightColorTokens; } });
var biome_dark_1 = require("./biome-dark");
Object.defineProperty(exports, "biomeDarkColorTokens", { enumerable: true, get: function () { return biome_dark_1.biomeDarkColorTokens; } });
//# sourceMappingURL=index.js.map